// extracted by mini-css-extract-plugin
export default {"root":"cWmT9","text":"lGq3a","translating":"u1R67","hidden":"ZBZvW","translationPlaceholder":"mEUjh","absolute":"DfmtL"};